import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentModule } from '@shared/component/shared-component.module';
import {RouterModule} from '@angular/router';
import { InquiryIndomaretComponent } from './inquiry-indomaret/inquiry-indomaret.component';
import { PaymentIndomaretComponent } from './payment-indomaret/payment-indomaret.component';
import { PaymentResultIndomaretComponent } from './payment-result-indomaret/payment-result-indomaret.component';
import { IndomaretModel } from '@shared/data/indomaret-model';



@NgModule({
  declarations: [
    InquiryIndomaretComponent,
    PaymentIndomaretComponent,
    PaymentResultIndomaretComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedComponentModule,
    FormsModule,
    RouterModule
  ],
  providers: [
    IndomaretModel  
  ]
})
export class IndomaretModule { }
